import {useState} from 'react';
import CreateIcon from '@material-ui/icons/Create';
import DeleteIcon from '@material-ui/icons/Delete';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibraryOutlined';
import {Button, Grid, Typography, Paper, IconButton} from "@material-ui/core";
import {useAlert} from 'react-alert';
import {toBase64} from '../utils/toBase64';
import {makeStyles} from "@material-ui/core/styles";
import AdditionalNotes from "../components/AdditionalNotes";
import {createLogo, updateLogo, deleteLogo} from '../api/image'
import UploadIconBlack from '../assets/icons/upload_black_32.png'
import UploadFileDialog from '../components/UploadFileDialog';
import HelpIcon from '@material-ui/icons/Help';
import ImageEditor from '../components/ImageEditor'
import StepNavigator from "../components/StepNavigator";
import Tooltip from '@material-ui/core/Tooltip';

const useStyles = makeStyles((theme) => ({
    container: {
        height: '100%',
        padding: 16,
        marginTop: 16,
        borderRadius: theme.shape.borderRadius,
        flex: '1',
        display: 'flex',
        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
        background: '#2f3135'
    },
    narrowGrid: {
        '& > .MuiGrid-grid-xs-2': {
            flexGrow: 0,
            maxWidth: '14%',
            flexBasis: '14%',
        },
        '& > .MuiGrid-grid-xs-10': {
            flexGrow: 0,
            maxWidth: '86%',
            flexBasis: '86%',
            '@media (max-width:1366px)': {
                flex: '1',
            },
        },
    },
    pageNavigation: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: theme.shape.borderRadius,
        background: '#32373D',
        boxShadow: '0px 4px 4px #000000',
        minWidth: 180,
        padding: '0 !important',
        overflow: 'hidden',
        '& ul': {
            '@media (max-width:1440px)': {
                paddingLeft: theme.spacing(2),
                fontSize: '0.75rem',
            },
        },
        '& .MuiButton-label': {
            '@media ( max-width: 1440px)': {
                fontSize: '0.70rem',
                '& > .MuiButton-startIcon img': {
                    height: 12,
                }
            }
        }
    },
    pageContent: {
        padding: `16px !important`,
        borderRadius: theme.shape.borderRadius,
        overflowY: 'auto',
    },
    content: {
        flex: '1',
        padding: 16,
        textAlign: 'center',
        width: '100%',
    },
    preview: {
        display: 'block', margin: '32px auto', height: 180, width: 180
    },
    logoWrapper: {
        background: '#585c60',
        width: '100%',
        aspectRatio: '1',
        maxWidth: 200,
        margin: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '100%',
        overflow: 'hidden',
        '& > img': {
            objectFit: 'cover',
            display: 'block',
            margin: 'auto',
            width: '100%',
            height: '100%',
            borderRadius: '100%'
        }
    }
}));


const SelectImageMessage = () => {
    return (
        <div style={{height: '100%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', textAlign: 'center'}}>
            <PhotoLibraryIcon style={{fontSize: '8rem', marginBottom: 16}} />
            <Typography>
                Please click on the <b>Upload Logo</b> button to add the logo <br />
            </Typography>
        </div>

    )
}
export default function EditLogoPage({data, token, onLoading, onUpdate, onNext, onPrev}) {
    const alert = useAlert();
    const classes = useStyles();

    const [isEditing, setIsEditing] = useState(false);
    const [uploadFileDialogActive, setUploadFileDialogActive] = useState(false);

    const onLogoUpdate = (image) => {
        console.log("Updating", image)
        if ( image ) {
            image.editedUri = image.editedUri + `?ts=${+Date.now()}`
        }
        onUpdate({
            ...data,
            provider: {...data.provider, logo: image, }
        })
        setIsEditing(false);
    }

    const onImageUpload = async (imageFile) => {
        console.log(imageFile)
        try {
            onLoading(true);
            const imageUri = await toBase64(imageFile)
            await createLogo({
                fileName: 'todo.png',
                originalUri: imageUri
            }, token)
                .catch(() => {alert.show("Failed to upload logo")})
                .then(res => {
                    console.log("got", res)
                    onLogoUpdate(res);
                    setUploadFileDialogActive(false);
                    onLoading(false);
                })
        } catch (e) {
            console.error(e);
        }
    }

    const onImageUpdate = async (image) => {
        console.log("update", image);
        try {
            await updateLogo({
                editData: image.editData,
                editedUri: image.editedUri
            }, token)
                .catch(() => {alert.show("Failed to update logo")})
                .then(res => {
                    console.log("got", res)
                    onLogoUpdate(res);
                })
        } catch (e) {
            console.error(e);
        }

    }

    const onImageDelete = async () => {
        console.log("delete")
        try {
            await deleteLogo(token)
                .catch(() => {alert.show("Failed to delete logo")})
                .then(res => {
                    console.log("got", res)
                    onLogoUpdate(null);
                })
        } catch (e) {
            console.error(e);
        }
    }

    const handleNoteChange = (value) => {
        const note = {
            sourceId: data.tokenType === 'BRANCH' ? data.branchId : data.provider._id,
            type: data.tokenType === 'BRANCH' ? 'PROVIDER_BRANCH_NOTE' : 'PROVIDER_NOTE',
            content: value,
        }
        onUpdate({
            ...data,
            provider: {...data.provider, note: note, }
        })
    }


    return (
        <>
            <Paper className={classes.container}>
                <Grid container spacing={1} alignItems="stretch" className={classes.narrowGrid}>
                    <Grid item xs={2} className={classes.pageNavigation}>
                        <div className={classes.content}>
                            <Tooltip title={data?.provider?.info?.name}>
                                <Typography variant="h5" style={{marginBottom: 32, marginTop: 16, width: '100%', maxHeight: '2rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                                    {data?.provider?.info?.name}
                                </Typography>
                            </Tooltip>
                            <div className={classes.logoWrapper}>

                                {
                                    (data?.provider?.logo == null) ? (
                                        <HelpIcon style={{fontSize: '6rem'}} />
                                    ) : (
                                        <img src={data?.provider?.logo?.editedUri} alt="Logo" />
                                    )
                                }
                            </div>
                            <div style={{marginTop: 32, textAlign: 'center'}}>
                                <Button size="large" onClick={() => setUploadFileDialogActive(true)}
                                    startIcon={<img src={UploadIconBlack} alt="upload" height="18" />}
                                    variant="contained" color="primary">
                                    Upload Logo
                                </Button>
                            </div>
                            <ul style={{textAlign: 'left'}}>
                                <li>The size of each picture should be no less than 500 Kb and no greater than 5 Mb. </li>
                                <li> The picture type should be .jpg or .jpeg or .png. </li>
                            </ul>
                        </div>
                        <AdditionalNotes value={data.provider?.note?.content} onChange={handleNoteChange} />
                    </Grid>
                    <Grid item xs={10} className={classes.pageContent}>
                        {data.provider.logo == null ? <SelectImageMessage /> : (
                            <div style={{height: '100%', position: 'relative', overflow: 'hidden'}}>
                                <ImageEditor
                                    aspectRatio={1}
                                    handleUpdate={onImageUpdate}
                                    handleCancel={() => setIsEditing(false)}
                                    isEditing={isEditing}
                                    editorHeight={450}
                                    outputHeight={450}
                                    exportType="image/webp"
                                    onControlsToggle={(state) => setIsEditing(state)}
                                    image={data?.provider?.logo} />
                                {
                                    isEditing ? (
                                        <img alt="preview" src={data?.provider?.logo?.editedUri} className={classes.preview} />
                                    ) : (
                                        <div style={{
                                            display: 'flex', flexDirection: 'row',
                                            justifyContent: 'flex-start', alignItems: 'flex-start', position: 'absolute', top: 0, right: 0
                                        }}>
                                            <IconButton onClick={() => setIsEditing(true)} >
                                                <CreateIcon style={{fontSize: '2rem'}} />
                                            </IconButton>
                                            <IconButton style={{color: "tomato"}} onClick={onImageDelete} >
                                                <DeleteIcon style={{fontSize: '2rem'}} />
                                            </IconButton>
                                        </div>
                                    )
                                }
                            </div>
                        )}
                    </Grid>
                </Grid>
            </Paper>
            <UploadFileDialog isOpen={uploadFileDialogActive} onClose={() => setUploadFileDialogActive(false)} onUpload={onImageUpload} />
            <StepNavigator disabled={isEditing} onNext={onNext} onPrev={onPrev} />
        </>
    )
}
